import './custom-terms-form.styles.scss';
import {
  DEFAULT_TERMS,
  MAX_TERM_LENGTH,
  getGameTerms
} from '@/utils/gameTerms';

const TERM_FIELDS = [
  { key: 'currency', label: 'Currency', example: 'Token' },
  { key: 'team', label: 'Teams', example: 'Guild' },
];

const CustomTermsForm = ({ formData, saveData, membership }) => {

  const terms = formData.terms ?? {};
  const locked = !membership || membership.membership < 1;
  const preview = getGameTerms({ terms });
  const hasCustomTerms = Object.values(terms).some(t => t?.singular);

  // matches the backend: letters, numbers, spaces, hyphens, and apostrophes
  function cleanInput(value) {
    return value
      .replace(/[^\p{L}\p{N} '-]/gu, '')
      .replace(/\s+/g, ' ')
      .substring(0, MAX_TERM_LENGTH);
  }

  function updateTerm(key, form, value) {
    const newTerms = { ...terms };
    newTerms[key] = { ...(terms[key] ?? {}), [form]: cleanInput(value) };
    saveData('terms', newTerms);
  }

  function resetTerms() {
    saveData('terms', {});
  }

  return (
    <div className='custom-terms-form'>
      <h3>Custom Terms</h3>
      <p>
        Rename Coins and Teams everywhere you and your players see them.
        Leave a field blank to use the default.
      </p>
      {
        (locked) &&
        <p className='meta'>
          Custom terms are available on Pro plans and above.
          {hasCustomTerms && ' Your current terms will stay in place, and you can still reset them to the defaults.'}
        </p>
      }
      <div className='custom-terms-fields'>
        {
          TERM_FIELDS.map(f => (
            <div key={f.key} className='custom-terms-row'>
              <div className='field small'>
                <label>{f.label} (singular)</label>
                <input
                  type='text'
                  value={terms[f.key]?.singular ?? ''}
                  placeholder={`${DEFAULT_TERMS[f.key].singular} (e.g. ${f.example})`}
                  maxLength={MAX_TERM_LENGTH}
                  disabled={locked}
                  onChange={(e) => updateTerm(f.key, 'singular', e.target.value)}
                />
              </div>
              <div className='field small'>
                <label>{f.label} (plural)</label>
                <input
                  type='text'
                  value={terms[f.key]?.plural ?? ''}
                  placeholder={
                    terms[f.key]?.singular
                      ? `${terms[f.key].singular}s`
                      : DEFAULT_TERMS[f.key].plural
                  }
                  maxLength={MAX_TERM_LENGTH}
                  disabled={locked}
                  onChange={(e) => updateTerm(f.key, 'plural', e.target.value)}
                />
              </div>
            </div>
          ))
        }
        <div className='g-list-item custom-terms-preview'>
          <b>Preview:</b> You earned {preview.formatCurrency(1)} and {preview.formatCurrency(25)} for
          your {preview.team.singularLower}. {preview.team.plural} compete for the most {preview.currency.pluralLower}.
        </div>
      </div>


      {
        (hasCustomTerms) &&
        <div className='buttons'>
          <button
            className='g-button small-btn'
            onClick={resetTerms}
          >
            Reset to Defaults
          </button>
        </div>
      }
    </div>
  )
}

export default CustomTermsForm
